<template>
    <b-card
            title="مدیریت محصول ها"
    >
        <b-row>
            <b-col
                    class="table-size"
            >
                <div class="custom-search">
                    <b-row>
                        <div class="filter-row">
                            <b-button
                                    class="mb-1 ml-1"
                                    variant="primary"
                                    :to="{ name: 'addproduct'}"
                            >
                                جدید
                            </b-button>
                            <b-button
                                variant="success"
                                class="mb-1 mr-auto ml-1"
                                @click="clearCache"
                            >
                                بروزرسانی
                            </b-button>
                            <b-col md="2">
                                <b-form-group
                                        label="عنوان"
                                        label-for="Title"
                                >
                                    <b-form-input
                                            v-model="filterOptions.Title"
                                            @keyup.enter="update(1)"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <b-form-group
                                        label="دسته بندی"
                                        label-for="Type">
                                    <product-category
                                            v-model="filterOptions.ProductCategoryId"
                                            :multiple="false"
                                            :clearable="true"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <b-form-group>
                                    <label>وضعیت</label>
                                    <v-select
                                            v-model="filterOptions.Status"
                                            :options="enums('ProductStatus')"
                                            dir="rtl"
                                            label="text"
                                            :reduce="x => x.value"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-button
                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                    class="mb-1 mr-1"
                                    variant="warning"
                                    @click="update(1)"
                            >فیلتر
                            </b-button>
                        </div>
                    </b-row>
                </div>

                <b-table
                        bordered
                        hover
                        striped
                        :items="items"
                        :fields="fields"
                        class="mt-1 mb-2 position-relative product-table"
                        responsive
                        :busy="loading"
                        :no-local-sorting="true"
                        :sort-by="filterOptions.SortBy"
                        :sort-desc="filterOptions.IsDesc"
                        @sort-changed="sortChange"
                >
                    <template #cell(Id)="data">
                        <b-link
                                :to="{ name: 'updateproduct', params: { id: data.value }}"
                                class="font-weight-bold"
                        >
                            #{{ data.value }}
                        </b-link>
                    </template>

                    <template #cell(Title)="data">
                        <div class="align-items-center d-flex">
                            <div>
                                <b-avatar
                                        class="mr-1"
                                        :src="data.item.Image"
                                />
                            </div>
                            <div>
                                {{ data.value }}
                            </div>
                        </div>
                    </template>

                    <template #cell(ProductCategory)="data">
              <b-badge
                      variant="light-info"
              >
                {{ data.value.Title }}
              </b-badge>
                    </template>

                    <template #cell(CreatedAt)="data">
            <span class="text-nowrap">
              {{ data.value | date }}
            </span>
                    </template>

                    <template #cell(Price)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Discount)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Visit)="data">
                        {{ data.value | price }}
                    </template>

<!--                    <template #cell(Status)="data">-->
<!--                        <b-badge-->
<!--                            v-if="data.item.HasVariety"-->
<!--                            variant="primary"-->
<!--                        >-->
<!--                             دارای تنوع-->
<!--                        </b-badge>-->
<!--                        <b-badge-->
<!--                            v-else-->
<!--                            :variant="enums('ProductStatus', 'value', data.value, 'badge')"-->
<!--                        >-->
<!--                            {{ enums('ProductStatus', 'value', data.value, 'text') }}-->
<!--                        </b-badge>-->
<!--                    </template>-->

                    <template #cell(actions)="data">

                        <div
                                class="text-nowrap"
                        >
                            <b-link
                                    :href="'/product/'+ data.item.Id+ '/'+data.item.Title.replace(' ', '-')"
                                    target='_blank'
                            >
                                <feather-icon
                                        icon="NavigationIcon"
                                        size="16"
                                />
                            </b-link>

                            <b-link :to="{ name: 'updateproduct', params: { id: data.item.Id }}">
                                <feather-icon
                                        :id="`invoice-row-${data.item.Id}-send-icon`"
                                        icon="EditIcon"
                                        size="16"
                                        class="ml-1"
                                />
                            </b-link>

                            <feather-icon

                                    icon="TrashIcon"
                                    size="16"
                                    class="ml-1"
                                    @click="remove(data.item.Id)"
                            />
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                </b-table>

                <z-pagination
                        :page="filterOptions.Page"
                        :total-rows="totalRows"
                        :loading="loading"
                        @change="update"
                />

            </b-col>

        </b-row>
    </b-card>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'
import Brand from '@/tools/brand.vue'

export default {
    name: 'Product',
    components: {
        ProductCategory,
        Brand
    },
    data() {
        return {
            totalRows: 1000 * 1000,
            loading: false,
            filterOptions: {
                Title: null,
                Page: 1,
                SortBy: 'Id',
                IsDesc: true,
                ProductCategoryId: null,
                Status: null,
            },
            fields: [
                {
                    key: 'Id',
                    label: '#',
                    thClass: 'col-width-50',
                },
                {
                    key: 'Title',
                    label: 'عنوان',
                },
                {
                    key: 'ProductCategory',
                    label: 'دسته بندی',
                },
                // {
                //     key: 'Weight',
                //     label: 'وزن',
                // },
                // {
                //     key: 'Wage',
                //     label: 'اجرت',
                // },
                // {
                //     key: 'Profit',
                //     label: 'سود',
                // },
                {
                    key: 'Price',
                    label: 'قیمت',
                },
                {
                    key: 'Discount',
                    label: 'تخفیف',
                },
                {
                    key: 'Visit',
                    label: 'بازدید',
                },
                {
                    key: 'Status',
                    label: 'وضعیت',
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: 'col-width-50',
                },
            ],
            items: [],
        }
    },
    computed: {
    },
    created() {
        if (this.$store.state.zirehState.listFilter[this.$options.name]) {
            this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
        }
        this.update()
    },
    methods: {
        sortChange(e) {
            if (e.sortBy) {
                this.filterOptions.SortBy = e.sortBy
                this.filterOptions.IsDesc = e.sortDesc
                this.update(1)
            }
        },
        update(pageNumber) {
            this.loading = true

            this.filterOptions.Page = pageNumber || this.filterOptions.Page

            this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

            this.$http.post(
                this.$api.product.getlist, this.filterOptions,
            )
                .then(res => {
                    this.totalRows = res.totalRow
                    this.items = res.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clearCache() {
            this.loading = true

            this.$http.post(
                this.$api.product.clearcache, null,
            )
                .then(res => {
                    this.update()
                })
        },
        remove(id) {
            this.removeRow(this.$api.product.remove, 'Id', id)
        },
    },
}
</script>
<style>
.product-table .badge-light-info {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>